// import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};

const CameraLocationsDB = [
    {
        cameraLocationId: 'WALL_START_FRONT',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Welcome',
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'WALL_START_BACK',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Manifesto',
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'W02PO1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Gallery 1',
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'W07P01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Courtyard',
        ObjectId:null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: 'W14P02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Gallery 2',
        ObjectId:null,
        displayMesh: 'Y',
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
